<template>
    <MainSlot>
        <div class="page_bg">
            <div v-if="is_loaded_page" class="events_header">
                <div class="title_text">
                    <div>{{ $t("Calendar['My calendar']") }}</div>
                </div>

                <div class="tabs">
                    <div class="tab"
                         :class="{active:selectedTab === tabs.future}"
                         @click="changeTab(tabs.future)"
                    >
                        {{ $t("Calendar['Future events']") }}
                    </div>
                    <div class="tab"
                         :class="{active:selectedTab === tabs.past}"
                         @click="changeTab(tabs.past)"
                    >
                        {{ $t("Calendar['Past events']") }}
                    </div>
                </div>

            </div>
            <div
                v-if="!events.length && is_loaded_page"
                class="empty_state_wrapper">
                <img v-if="selectedTab == 'future'" src="../assets/img/empty_state_image.svg" alt="empty state image">
                <img v-else src="../assets/img/empty_state_image.svg" alt="empty state image">
                <span v-if="selectedTab == 'future'"
                      class="empty-state-text">{{ $t("Calendar['You don’t have any future events yet.']") }}</span>
                <span v-else class="empty-state-text">{{ $t("Calendar['You don’t have any past events yet.']") }}</span>
            </div>
            <div v-else-if="events.length && is_loaded_page" class="events_container">
                <div class="row">
                    <div
                        v-for="app_event of events"
                        class="col s12 m6 l4">
                        <div
                            class="card"
                            @click="cardClick(app_event.id)"
                            :class="{
                                past: selectedTab === 'past',
                            }"
                            @mouseover="setCardHover(app_event.id)"
                            @mouseout="setCardHover(null)"
                            :style="{backgroundImage:`url( '${app_event.image.url}' )`}"
                        >
                            <div class="card_body"></div>
                            <div class="card_content">
                                <div class="head_block">
                                    <div class="title">
                                        {{ app_event.title }}
                                    </div>
                                    <div class="info">
                                        <span>
                                            {{ dateTitle(app_event, selectedTab) }}
                                        </span>
                                    </div>
                                </div>

                                <div class="hovered_content">
                                    <div class="item">
                                        <span class="img"><img src="../assets/img/location_brand.svg"
                                                               alt="location_brand icon"></span>
                                        <span class="text">{{ app_event.location }}</span>
                                    </div>
                                    <div class="item">
                                        <span class="img"><img src="../assets/img/room-size_brand.svg" alt="room-size"></span>
                                        <span class="text">{{ app_event.seats_min }}
                                            {{
                                                app_event.seats_max ? ` - ${app_event.seats_max}` : ''
                                            }} {{ $t("Calendar['users per conversation']") }}</span>
                                    </div>
                                    <div class="item">
                                        <span class="img">
                                            <img src="../assets/img/host_brand.svg"
                                                 alt="host brand">
                                        </span>
                                        <span class="text">{{ app_event.organisation }}</span>
                                    </div>
                                    <div class="item">
                                        <span class="img">
                                            <img src="../assets/img/tag_brand.svg" alt="tag icon">
                                        </span>
                                        <span class="text">{{
                                                app_event.tags.reduce((accumulator, currentValue) => {
                                                    return accumulator
                                                        ? `${accumulator}, ${currentValue.title}`
                                                        : `${currentValue.title}`;
                                                }, '')
                                            }}</span>
                                    </div>
                                    <div class="desc">
                                        {{ shortDescription(app_event) }}
                                    </div>
                                </div>

                                <div class="footer">
                                    <div v-if="selectedTab !== 'past'" class="reserved_text">
                                        <div v-if="app_event.is_online" class="center">
                                            {{ $t("Events['You’ve already reserved a seat']") }}
                                        </div>
                                        <div v-else class="center">
                                            {{ $t("Events['You’ve already reserved a seat']") }}
                                        </div>
                                    </div>
                                    <div v-else class="reserved_text">
                                        <template v-if="selectedTab === tabs.past">
                                            <div class="ev_type">
                                                {{
                                                    app_event.is_online ? $t("Calendar['Online event']") : $t("Calendar['Offline event']")
                                                }}
                                            </div>
                                            <template v-if="app_event.count_friends">
                                                <div class="friend_counter">
                                                    <img src="../assets/img/hands-up.svg" class="img-hand"
                                                         alt="hands up">
                                                    <span class="past-friends">{{
                                                            app_event.count_friends
                                                        }} {{ $t("Calendar['friends']") }}</span>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="friend_counter">
                                                    <span class="past-friends">{{ $t("Calendar['No matches']") }}</span>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </MainSlot>
</template>

<script>
import {errorMessage} from "@/services/messges";
import {mapGetters, mapMutations} from "vuex";
import moment from "moment-timezone";
import {eventDurationString} from "@/services/tools";

export default {
    data() {
        return {
            tabs: {
                future: 'future',
                past: 'past'
            },
            selectedTab: 'future',
            events: [],
            total_count: 0,
            serverParams: {
                filter: {},
            },
            clicked_event_id: null,
            hover_event_id: null,
        };
    },
    methods: {
        ...mapMutations([
            'setLoading',
            'set_is_loaded_page'
        ]),
        setCardHover(value) {
            this.hover_event_id = value;
        },
        async cardClick(event_id) {
            if (this.selectedTab == "future") {
                if ((event_id == this.clicked_event_id) || (event_id == this.hover_event_id)) {
                    await this.$router.push('/events-app/' + event_id + '/details');
                    this.clicked_event_id = null;
                } else {
                    this.clicked_event_id = event_id;
                }
            } else if (this.selectedTab == 'past') {
                await this.$router.push('/events-app/' + event_id + '/past-details');
                this.clicked_event_id = null;
            }

        },
        changeTab(tab) {
            this.selectedTab = tab;
            this.set_is_loaded_page(false);
            this.loadItems();
        },
        async loadItems() {
            try {
                this.setLoading(true);
                this.serverParams.filter.active_tab = this.selectedTab;
                const response = await this.$http.postAuth(`${this.$http.apiUrl()}users/events/calendar-list`,
                    this.serverParams);
                this.events = response?.data?.data?.list || [];
            } catch (e) {
                console.log(e);
                errorMessage(e?.response?.data?.error?.message || this.$t("validation['OOPS... Something went wrong...']"));
            }
            this.set_is_loaded_page(true);
        },

        dateTitle(app_event, tab) {
            return moment(app_event.start_date_time).format('DD.MM.YYYY, HH:mm');
        },
        timeTitle(app_event) {
            return moment(app_event.start_date_time).format('DD.MM.YYYY, HH:mm');
        },
        durationOfEvent(event) {
            return eventDurationString(event);
        },
        shortDescription(app_event) {
            const desc = app_event.description;
            return desc.length < 220 ? desc : desc.substr(0, 220) + '...';
        },
    },
    async mounted() {
        this.set_is_loaded_page(false);
        await this.$emit('check-login');
        if (this.isLoginChecked) {
            await this.loadItems();
        }
    },
    computed: {
        ...mapGetters([
            'isLoginChecked',
            'is_loaded_page',
        ]),
    },
    watch: {
        async isLoginChecked(val) {
            if (val) {
                await this.loadItems();
            }
        },
    },
    metaInfo: {
        title: 'Calendar Page',
        titleTemplate: '%s | Speed Friending Webapp'
    },
    name: "Calendar"
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

.events_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-height: 56px;
    margin-bottom: 20px;
}

.empty_state_wrapper {

    @media screen and (max-width: 600px) {
        .logged & {
            margin: auto;
        }
    }

    .empty-state-text {
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 20px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #A4A0BA;
    }
}

.tabs {
    height: 56px;
    width: auto;
    box-shadow: 3px 6px 12px rgba(58, 1, 67, 0.05);
    padding: 4px;
    border-radius: 28px;
    display: flex;
    align-items: flex-end;
    margin: 0;
    font-weight: 700;

    .tab {
        text-transform: none;
        height: 100%;
        color: $brand-color;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 32px;
        border-radius: 28px;
        cursor: pointer;

        &.active {
            color: white;
            background: #9235A1;
        }
    }
}

.card {
    cursor: pointer;

    &.past {
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
    }

    width: 350px;
    max-width: 100%;
    height: 400px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    border-radius: 24px;
    overflow: hidden;

    .reserved_text {
        display: flex;
        height: 100%;
        width: 100%;
        align-items: center;
        justify-content: center;
        color: white;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 20px;

        .center {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            svg {
                margin-right: 10px;
            }
        }

        .img-hand {
            margin-right: 10px;
        }

        .past-friends {
            font-family: Source Sans Pro;
            font-style: normal;
            font-weight: bold;
            font-size: 15px;
            line-height: 19px;

            text-align: center;
            text-transform: uppercase;

            color: #FFFFFF;
        }
    }

    .card_content {
        position: absolute;
        height: 100%;
        width: 100%;
        padding: 15px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        z-index: 1;

        .hovered_content {
            height: 0;
            overflow: hidden;

            .desc {
                margin-top: 15px;
                font-style: normal;
                font-weight: normal;
                font-size: 15px;
                line-height: 20px;
                color: white;
                height: 100px;
                max-height: 100px;
            }

            .item {
                padding: 15px 0 0;
                display: flex;
                align-items: center;
                justify-content: flex-start;

                .text {
                    font-style: normal;
                    font-weight: normal;
                    font-size: 15px;
                    line-height: 20px;
                    color: white;
                }

                .img {
                    padding-right: 7px;
                    display: flex;
                }
            }

        }

        .head_block {
            color: white;

            .info {
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-style: normal;
                font-weight: 600;
                font-size: 13px;
                line-height: 16px;
                color: white;
                padding-top: 3px;

                .time {
                    margin-left: 20px;
                }
            }

            .title {
                font-style: normal;
                font-weight: bold;
                font-size: 18px;
                line-height: 23px;
            }
        }

        .footer {
            margin-top: 15px;
            height: 56px;

            .reserved_text {
                justify-content: space-between;

                .ev_type {
                    svg {
                        margin-right: 10px;
                    }
                }

                div {
                    display: flex;
                    align-items: center;
                }
            }
        }
    }

    &:hover {
        .hovered_content {
            height: 255px;
        }

        .card_body, .card_body_second {
            background-color: #3A0143cc;
            //background:  linear-gradient(90deg, #FA604A 0%, #9235A1 100%);
        }
    }

    .card_body {
        position: absolute;
        height: 100%;
        width: 100%;
        padding: 15px;
        background: linear-gradient(180deg, rgba(58, 1, 67, 0) 45.06%, rgba(58, 1, 67, 0.84) 74.04%, #3A0143 100%);;
        opacity: 0.75;
    }

    .card_body_second {
        position: absolute;
        height: 100%;
        width: 100%;
        padding: 15px;
        background: linear-gradient(90deg, #FA604A 0%, #9235A1 100%);;
        opacity: 0.75;
    }

}

@media screen and (max-width: 601px) {
    .events_header {
        display: block;

        .title_text {
            margin-top: 20px;
            margin-left: 20px;
        }

        .tabs {
            width: 70%;
            margin-left: 15%;
            margin-top: 10px;
        }
    }
    .events_container {
        margin-top: 30px;

        .row .col.s12.m6.l4 {
            margin-top: 20px;
        }
    }
    .card {
        margin: 0 auto;
    }
}

@media screen and (max-width: 420px) {

    .events_header .tabs {
        width: 90%;
        margin-left: 5%;
    }
}
</style>
